import HelpApi from '@/api/help'
// initial state
const state = {
  list: []
}

// getters
const getters = {
  getList (state) {
    return state.list
  }
}

// actions
const actions = {
  setList (store, data) {
    store.commit('setList', data)
  },
  async fetchList (store, data) {
    let list = await HelpApi.getList()
    store.commit('setList', list)

    return list
  }
}

// mutations
const mutations = {
  setList (state, data) {
    state.list = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
